<template>
    <v-card 
        class="mt-4" 
        flat
    >
        <!-- 1st Row  -->
        <v-row align="center" justify="center">
            <v-col cols="5">                                                                
                <v-autocomplete
                    v-model="selectedSubject"
                    label="Subject"
                    hide-details
                    outlined
                    dense
                    :items="subjects"
                    item-text="title"
                    item-value="id"
                    chips
                    small-chips
                    deletable-chips
                    @change="getStudentsAssigned"
                    height="20"
                ></v-autocomplete>                
            </v-col>

            <v-col cols="2">
                <v-select
                    v-model="selectedFormLevel"
                    label="Form"
                    hide-details
                    outlined
                    dense
                    chips
                    small-chips
                    deletable-chips
                    :items="formLevelItems"
                    @change="setStudentsList"
                ></v-select>
            </v-col>

            <v-col cols="3">                  
                <v-select
                    v-model="selectedFormClass"
                    label="Class"
                    hide-details
                    outlined
                    dense
                    chips
                    small-chips
                    deletable-chips
                    :items="formClassOptions"
                    item-text="id"
                    item-value="id"
                    @change="setStudentsList"
                ></v-select>
            </v-col>

            <v-col cols="2">
                <v-select
                    v-model="displayStudents"                    
                    outlined                    
                    label="Display"                    
                    :items="displayOptions"                                                       
                    hide-details
                    dense
                    @change="filterDisplay"
                ></v-select>
            </v-col>            
        </v-row>
            
        <!-- 2nd Row -->
        <v-row>
            <v-col cols="6" class="pt-0">                   
                <v-autocomplete
                    v-model="selectedTeacher"
                    label="Teacher"
                    hide-details
                    outlined
                    dense
                    :items="teachers"
                    item-text="display_name"
                    item-value="id"
                    chips
                    small-chips
                    deletable-chips                    
                ></v-autocomplete>
            </v-col>

            <v-col cols="2" class="pt-0">
                <v-text-field
                    outlined
                    disabled
                    label="Assigned"
                    v-model="studentsAssignedCount"
                    hide-details
                    dense
                ></v-text-field>
            </v-col>

            <v-col cols="4" class="pt-0">
                <v-text-field
                    v-model="search"
                    label="Search Student"
                    append-icon="mdi-magnify"
                    outlined
                    clearable
                    hide-details
                    dense
                ></v-text-field>
            </v-col>

            
        </v-row>

        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="studentsList"
            fixed-header                        
            height="48vh"         
            :search="search"
            :loading="loading"
            show-select
            dense                
        >
            <template v-slot:[`item.assigned`]="{ item }">
                <v-icon
                    v-if="item.assigned"
                    color="primary"
                >
                    mdi-checkbox-marked-outline
                </v-icon>
            </template>            
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                class="mr-4"
                depressed
                @click="unassignStudents"
            >
                Unassign Students
            </v-btn>
            <v-btn
                color="primary"
                @click="assignStudents"
            >
                Assign Students
            </v-btn>
        </v-card-actions>

        <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :centered="snackCentered"            
        >
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="snackbar = false"                   
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>        
    </v-card>      
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props: {
        subjects: {
            type: Array,
            default: function () {
                return [];
            }
        },

        teachers: {
            type: Array,
            default: function () {
                return [];
            }
        },

        formLevels: {
            type: Array,
            default: function () {
                return [];
            }
        },

        formClasses: {
            type: Array,
            default: function () {
                return [];
            }
        },       

        students: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },

    mounted: function () {
        this.initialize();
    },

    computed: {
        formClassOptions () { 
            if(this.formClassId){
                return [this.formClassId];
            }          
            if(this.selectedFormLevel){ 
                return this.formClasses.filter(value => {
                    if(value.form_level == this.selectedFormLevel ) 
                    return value;
                })
            } 
            return this.formClasses;           
        },

        studentsAssignedCount () {
            if(this.subjectStudentsAssigned.length == 0) return '-';
            return this.subjectStudentsAssigned.length;
        },

        ...mapGetters({
            formClassId: 'auth/getFormClassId',
            formLevel: 'auth/getFormLevel',
        })
        
    },

    data: function(){
        return {
            selectedSubject: null,
            selectedTeacher: null,
            selectedFormLevel: null,
            selectedFormClass: null,
            headers: [
                {text: 'ID', align: 'start', value: 'id', width: '70'},
                {text: 'Name',  value: 'name'},            
                {text: 'Class', value: 'class_id', width: '100'},            
                {text: 'Teacher',  value: 'teacher' },
                {text: 'Assigned',  value: 'assigned', align: 'center' },
            ],       
            search: '',
            loading: false,
            selected: [],
            studentsList: [],
            studentsAssigned: [],
            subjectStudentsAssigned: [],
            displayOptions: [ "All", "Assigned", "Unassigned"],                
            displayStudents: "",
            overlay: false,
            overlayText: '',
            snackbar: false,
            snackColor: '',
            snackText: '',
            snackCentered: false,
            formLevelItems: this.formLevels,
            formClassItems: this.formClasses,
    }},

    watch: {
        selectedFormLevel: {
            handler () {
                console.log("form level changed");
                if(this.formClassId === null){
                    this.selectedFormClass = null;
                    this.displayStudents = "All";
                    this.setStudentsList();
                }
            }
        },

        
        selectedFormClass: {
            handler () {
                // console.log(`Form Class: ${value}`);
                this.displayStudents = "All";
            }
        }
    },

    methods: {
        ...mapActions({
            getSubjectStudents: 'admin/getSubjectStudents',
            postSubjectStudentsAssignment: 'admin/postSubjectStudentsAssignmentBatch',
            postSubjectStudentsUnassignment: 'admin/postSujectStudentsUnassignmentBatch',
        }),

        ...mapMutations({
            setSubject: 'admin/setSubjectSelected',
            setSubjectStudentsAssignment: 'admin/setSubjectStudentsAssignment',
        }),
        
        initialize () {
            console.log("Initializing subject batch...");
            this.displayStudents = "All";            
            this.selected = [];
            this.studentsList = [];
            this.studentsAssigned = [];
            this.subjectStudentsAssigned = [];
            
            if(this.formLevel){
                this.selectedFormLevel = Number(this.formLevel);
                this.formLevelItems = [Number(this.formLevel)];
            } 
            if(this.formClassId){
                this.selectedFormClass = this.formClassId;
                
            } 
            console.log('subject batch finish')
            // this.$emit('show-overlay', false)
        },
        
        async getStudentsAssigned () {
            this.studentsAssigned = [];
            if(this.selectedSubject){
                this.setSubject(this.selectedSubject);
                try {
                    const { data } = await this.getSubjectStudents();
                    this.studentsAssigned = data;
                } catch (error) {
                    error.response ? console.log(error.response) : console.log(error);
                }
            }
            this.setStudentsList();
        },

        setStudentsList () {
            this.studentsList = [];

            if(
                this.selectedSubject && 
                this.selectedFormLevel && 
                !this.selectedFormClass
            )
            {
                console.log("only form level selected");
                this.studentsList = this.students.filter(value => {
                    if(value.form_level == this.selectedFormLevel) 
                    return value;
                })
                this.setStudentsAssigned();
                return;
            }
            
            if(this.selectedSubject && this.selectedFormClass)
            {                
                console.log("class id and subject id selected");
                this.studentsList = this.students.filter(value => {
                    if(value.class_id == this.selectedFormClass)
                    return value;
                })
                this.setStudentsAssigned();
                return;
            }
                       
            this.studentsList = [];
        },

        setStudentsAssigned () {
            let student = null; 
            let teacher = null;
            this.selected = [];
            this.subjectStudentsAssigned = [];

            this.studentsList = this.studentsList.map(value => {
                student = this.studentsAssigned.filter(item => {
                    if(item.id == value.id) return item;
                })
                value.assigned = false;
                value.teacher = null;
                value.employee_id = null;
                if(student.length > 0){
                    teacher = null;
                    if(student[0].employee_id){
                        teacher = this.teachers.filter(teacher => {
                            if(teacher.id == student[0].employee_id)
                            return teacher;
                        })[0].display_name;
                        
                    }
                    value.teacher = teacher;
                    value.assigned = true;
                    value.employee_id = student[0].employee_id;
                    this.subjectStudentsAssigned.push(value);
                    // this.selected.push(value);
                    // console.log(student);
                }
                return value;
            })
        },

        assignStudents () {
            if(this.selected.length == 0){
                this.snackColor = "red";
                this.snackText = "No students selected for assignment";
                this.snackbar = true;
                this.snackCentered = true;
                return;
            }

            this.setSubjectStudentsAssignment({
                form_level: this.selectedFormLevel,
                class_id: this.selectedFormClass,
                students: this.selected,
                employee_id: this.selectedTeacher,
                subject_id: this.selectedSubject
            })

            this.postAssignment();
            
        },

        async unassignStudents () {
            if(this.selected.length == 0){
                this.snackColor = "red";
                this.snackText = "No students selected";
                this.snackbar = true;
                this.snackCentered = true;
                return;
            }

            this.setSubjectStudentsAssignment({
                form_level: this.selectedFormLevel,
                class_id: this.selectedFormClass,
                students: this.selected,
                employee_id: this.selectedTeacher,
                subject_id: this.selectedSubject
            })

            try {
                this.$emit('show-overlay', true)
                const { statusText } = await this.postSubjectStudentsUnassignment();
                console.log(statusText);
                this.getStudentsAssigned();
                this.$emit('show-overlay', false)
                this.$nextTick(() => {
                    let msg = `${ this.selected.length} Student Unassigned`;
                    if(this.selected.length > 1)
                    msg = `${ this.selected.length} Students Unassigned`;
                    this.snackText = msg;
                    this.snackColor = "primary";
                    this.snackCentered = false;                    
                })
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.snackText = "An error has occured.";
                this.snackColor = "red";
                this.snackCentered = false;
                this.$emit('show-overlay', false);
            }

            
            this.snackbar = true;
            
        },

        async postAssignment () {
            this.$emit('show-overlay', true)
            try {
                const { statusText } = await this.postSubjectStudentsAssignment();
                console.log(statusText);
                this.displayStudents = "All";
                this.getStudentsAssigned();
                // this.setStudentsList();
                this.$emit('show-overlay', false);
                this.$nextTick(() => {
                    let msg = `${ this.selected.length} Student Assigned`;
                    if(this.selected.length > 1)
                    msg = `${ this.selected.length} Students Assigned`;
                    this.snackText = msg;
                    this.snackColor = "primary";
                    this.snackCentered = false;                    
                })
            } catch (error) {
                this.$emit('show-overlay', false);
                error.response ? console.log(error.response) : console.log(error);
                this.snackText = "An error has occured.";
                this.snackColor = "red";
                this.snackCentered = false; 
            }
            this.snackbar = true;
        },

        filterDisplay () {            
            let studentAssigned = null;
            switch (this.displayStudents){
                case "All":
                    this.setStudentsList();
                    break;
                case "Assigned":
                    this.setStudentsList();                    
                    this.studentsList = this.studentsList.filter(value => {
                        studentAssigned = this.studentsAssigned.filter(item => {
                            if(item.id == value.id) return item;
                        })
                        if(studentAssigned.length > 0){
                            return value;
                        }
                    })
                    break;
                case "Unassigned":
                    this.setStudentsList();
                    this.studentsList = this.studentsList.filter(value => {
                        studentAssigned = this.studentsAssigned.filter(item => {
                            if(item.id == value.id) return item;
                        })
                        if(studentAssigned.length == 0){
                            return value;
                        }
                    })
                    break;        
           }
        },

        
    }
}
</script>

<style scoped>
    ::v-deep .v-input{
        font-size: 12px;
    }

    ::v-deep .v-text-field input{
        text-align: center;
    }

    ::v-deep .v-select__selections{
        flex-wrap: nowrap;
    }

    ::v-deep .v-data-footer {
        justify-content: flex-start;
    }

    ::v-deep .v-card__actions {
        position: absolute;
        right: 0;
        bottom: 0;
    }

    ::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small.v-input--dense .v-select__selections {
        min-height: 20px;
    }
</style>